import { NOTIFICATION_INLINE_LIST_PRIORITIES } from './NotificationInlineList.constants'

function notificationsComparator(notification1, notification2) {
  return (
    NOTIFICATION_INLINE_LIST_PRIORITIES[notification2.type] -
    NOTIFICATION_INLINE_LIST_PRIORITIES[notification1.type]
  )
}

export function getSortedNotifications(notifications) {
  return [...notifications.sort(notificationsComparator)]
}
